import { PresetManager } from "@bryntum/schedulerpro";

// This preset is not supplied in default presets by bryntum, adding it so it gets available on scheduler
// see PresetManager.defaultConfig.defaultPresets in PresetManage.js file
PresetManager.add(PresetManager.getById("dayAndWeek"));

// This patch is required to synchronize time resolution with preset lowest header (tick) to make
// resize feature to snap dates to ticks.
// https://github.com/Swivu/swivu-client/issues/551
PresetManager.forEach(preset => {
  const bottomHeader = preset.headers[preset.headers.length - 1];

  PresetManager.registerPreset(preset.id, {
    id: preset.id,
    base: preset.id,
    timeResolution: {
      unit: bottomHeader.unit,
      increment: bottomHeader.increment || 1
    }
  });
});